export const STATIC_PREFIX = "/api/uploads";
